import { lazy } from 'react';

// Types
import { ClickAndCollectCountdownProps as LazyComponentProps } from './ClickAndCollectCountdown.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "clickAndCollectCountdown" */ './ClickAndCollectCountdown')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'ClickAndCollectCountdown');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as ClickAndCollectCountdown };
